import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpChildProvider extends HttpService{

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * 予約履歴取得
   */
  getReserveHistory(conditions): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/children/getReserveHistory");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 保存処理
   */
  save(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/children/save");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }
}


// WEBPACK FOOTER //
// ./src/providers/http-child.ts